import { ChangeEvent, useState, useEffect } from "react";
import logoImg from "../../assets/images/logo1.png";
import accountImg from "../../assets/images/account.png";
import passwordImg from "../../assets/images/password.png";
import { message, Modal } from "antd";
import useGlobalModel from "../../model/globalModel";
import { useHistory } from "react-router-dom";
import "./Login.scss";
import { setToken, defaultMdCmParam, CLIENT_APP_CODE } from "../../utils/constants";
import { loginServiceAuth2 } from "./LoginServiceAuth2";
import { globalPrompt } from "@/components/message";
import { debounce } from "lodash";
import { SmileTwoTone, ToolOutlined } from "@ant-design/icons";
import { restaurantService } from "../restaurant/restaurantServices";
import { IRestaurantFields } from "../restaurant/restaurantTypes";
import { DetailDrawer } from "./DetailDrawer";

interface IgetIpType {
    cid: string,
    cip: string,
    cname: string,
}
declare const window: Window & { returnCitySN?: IgetIpType };

export const Login = () => {
    const history = useHistory()
    const { user, setUser, setResourceAuth, setMenuAuth } = useGlobalModel();

    const [state, setstate] = useState({
        account: '',
        password: '',
        token: ''
    });

    const [checkPwd, setCheckPwd] = useState<boolean>(() => {
        let account = window.localStorage.getItem('account');
        let password = window.localStorage.getItem('password');
        if (account || password) {
            return true
        }
        return false
    });

    const [loading, setLoading] = useState<boolean>(false);

    const onAccountChange = (e: ChangeEvent<HTMLInputElement>) => {
        setstate({ ...state, account: e.target.value });
        checkPwd && window.localStorage.setItem('account', e.target.value);

    }
    const onPasswordChange = (e: ChangeEvent<HTMLInputElement>) => {
        setstate({ ...state, password: e.target.value })
        checkPwd && window.localStorage.setItem('password', e.target.value);
    }

    //回显记住账号密码
    useEffect(() => {
        let account = window.localStorage.getItem('account');
        let password = window.localStorage.getItem('password');

        if (account || password) {
            setstate({
                ...state,
                account: account ?? "",
                password: password ?? ""
            });
        }
    }, []);

    useEffect(() => {
        user.token && history.push('/restaurant')
    }, [user.token])

    const [visible, setVisible] = useState<boolean>(false);
    // 登录
    const doLogin = debounce(async () => {
        try {
            if (!state.account) {
                message.warning("请输入账号");
                setLoading(false)
                return;
            }
            if (!state.password) {
                setLoading(false);
                message.warning("请输入密码");
                return
            }
            let { retData, retMsg } = await loginServiceAuth2.Login({
                account: state.account,
                password: state.password,
                code: ""
            });
            setToken(retData.token)
            let { retData: canteenData } = await restaurantService.page({ page: { pageSize: 1000, pageNum: 1 } }, retData.token);
            let { data, ...pg } = canteenData;
            //配置用户登录的餐厅信息
            if (retData) {
                let setShopModal = Modal.confirm({
                    title: <span style={{ fontSize: "20px", fontWeight: "bold" }}>请选择餐厅</span>,
                    centered: true,
                    closable: true,
                    icon: <ToolOutlined />,
                    className: "login-shop-modal",
                    content: <div className="login-shop-container">
                        {
                            data && data.length > 0 ? data.map(item => (
                                <span key={item.id} onClick={() => setCanteenInfo(item)}>{item.name}</span>
                            )) : <span onClick={() => { setVisible(true); setShopModal.destroy() }} style={{ background: "#FD8700" }}>去增加餐厅</span>
                        }
                    </div>,
                    // onCancel: () => { loginServiceAuth2.Logout(); setLoading(false); }
                    onCancel: () => { setLoading(false); }
                });
                const setCanteenInfo = (canteen: IRestaurantFields) => {
                    setUser({ ...(retData.userInfo ?? {}), token: retData.token, canteenName: canteen.name, canteenId: canteen.id });
                    globalPrompt("notification", {
                        type: "success", title: "登录成功",
                        duration: 3,
                        text: <p className="bold"><span className="block"><SmileTwoTone /></span>欢迎使用报餐管理系统</p>
                    });
                    setShopModal.destroy();
                }

            } else {
                message.error("登录失败：" + retMsg);
                setLoading(false)
            }
        } catch (error) { setLoading(false) }
    }, 800);


    //记住密码
    const checkout = (e: any) => {
        let checked = e.target.checked;
        if (checked) {
            setCheckPwd(true);
            window.localStorage.setItem('account', state.account);
            window.localStorage.setItem('password', state.password);
        } else {
            setCheckPwd(false);
            window.localStorage.removeItem('account');
            window.localStorage.removeItem('password');
        }
    };

    return (
        <div className="container-login">
            <div className="login-warp">
                <div className="bg1">
                    <img src={logoImg} alt="" className="login-logo" />
                    <p>让天下商用车用户全程无忧</p>
                    <p>让我们的员工及合作伙伴都能过上好日子</p>
                </div>

                <div className="input-box">
                    <div className="input-title">
                        <span>用户登录</span>
                    </div>
                    <p className="account">
                        <span><img src={accountImg} alt="" /></span>
                        <input type="text" placeholder='请输入账号' value={state.account} onChange={onAccountChange}
                            onKeyUp={(e) => {
                                if (e.keyCode === 13) {
                                    setLoading(true);
                                    !loading && doLogin();
                                }
                            }} />
                    </p>
                    <p className="password">
                        <span><img src={passwordImg} alt="" /></span>
                        <input type='password' placeholder='请输入密码' value={state.password} onChange={onPasswordChange}
                            onKeyUp={(e) => {
                                if (e.keyCode === 13) {
                                    setLoading(true);
                                    !loading && doLogin();
                                }
                            }} />
                    </p>
                    <div className="login-input-three">
                        <span><input type="checkbox" defaultChecked={checkPwd} onClick={checkout} /> 记住密码</span>
                    </div>
                    <p className="login-but" onClick={() => {
                        setLoading(true);
                        doLogin();
                    }}>登录</p>

                    {loading && <div className="caseMarronFonce">
                        <div className="spinner"></div>
                        <div className="spinner-text">登录中。。。</div>
                    </div>}
                </div>
            </div>
            <DetailDrawer
                visible={visible}
                onCancel={() => { setVisible(false); setLoading(false) }}
            />
        </div>
    )
}

export default Login;